<template>
  <div class="container">
    <app-header title="我的优惠劵"></app-header>
    <!-- 分类 -->
    <div class="tabs">
      <div class="tab">
        <div class="item" v-for="(item,index) in tabList" :key="index">
          <div @click="handleTag(index)" :class="activeTag==index ? 'active':''">{{item}}</div>
        </div>
      </div>
    </div>
    <div v-for="item in couponList" :key="item.id">
      <div class="rechargeimg" :style="rechargeimg"  @click="$router.push('/category')" style="height: 115px; width: 95%;margin-left: 2%">
        <div class="name ellipsis">{{item.title}}</div>
        <div class="price">
          <span>￥{{item.money}}</span>
          <span>(满{{item.conditions}}元使用)</span>
        </div>
        <div class="date">
          <div>有效期：{{item.shopCoupon.endTime}}</div>
          <div>剩余{{item.shopCoupon.number}}张</div>
        </div>
      </div>
    </div>
    <div v-if="!couponList.length" style="width: 100%;height: 150px;line-height: 150px;text-align: center;">
      暂无数据
    </div>

    <div style="height: 100px;"></div>

    <van-tabbar class="active_tab">
      <div class="record" style="color:rgba(51,51,51,1);" @click="myCoupon">
        <div class="recordtitle">优惠券历史记录</div>
        <img src="@/assets/addgo.png" alt="" width="15" height="15" class="reco">
      </div>
      <div class="henxian"></div>
      <div class="record" style="color: #FE003B" @click="core">
        <div class="recordtitle">  去领劵中心</div>
        <img src="@/assets/right.png" alt="" width="15" height="15" class="reco">
      </div>
    </van-tabbar>
  </div>
</template>

<script>
import { queryShopCouponList,myCoupon } from '@/api/coupon/index.js'
export default {
  name: 'Index',
  data() {
    return {
      rechargeimg: {
        backgroundImage: 'url(' + require('@/assets/use.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%',
        mozBackgroundSize: '100% 100%'
      },
      active: 0,
      activeTag: 0,
      tabList: ['全部', '电子元器件', '电子产品', '其他'],
      couponList: []
    }
  },
  created() {
    this._queryShopCouponList()
  },
  methods: {
    // 优惠劵列表
    _queryShopCouponList() {
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      const params = {
        uid: user.id,
        type: this.activeTag
      }
      myCoupon(params).then((res) => {
        if (res.success) {
          this.couponList = []
          res.data.forEach((item)=>{
             if(!item.status){
              this.couponList.push(item)
             }
          })
        }
      })
    },
    handleTag(index) {
      this.activeTag = index
      if (index === 0) {
        this.show = true
      } else {
        this.show = false
      }
      this._queryShopCouponList()
    },
    myCoupon() {
      this.$router.push('/myCoupon')
    },
    core() {
      this.$router.push('/core')
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    .tabs{
      display: flex;
      flex-direction: row;
      align-items: center;
      height:44px;
      padding: 0 12px;
      .tab{
        display: flex;
        flex-direction: row;
        flex: 1;
        justify-content: space-between;
        .item{
          font-size:14px;
          font-weight:500;
          height:22px;
          font-family:PingFang SC;
          line-height:22px;
          color:rgba(51,51,51,1);
          margin-right: 14px;
          .active{
            font-size:16px;
            font-weight:bold;
            color: #FE003B;
            border-bottom: 3px solid #FE003B;
          }
        }
      }
    }
    .name{
      width: 80%;
      font-size:18px;
      font-family:PingFang SC;
      font-weight:bold;
      line-height:25px;
      color:rgba(51,51,51,1);
      opacity:1;
      padding-top: 27px;
      text-align: center;
    }
    .price{
      width: 80%;
      font-size:18px;
      font-family:PingFang SC;
      font-weight:bold;
      line-height:25px;
      color:rgba(255,0,0,1);
      text-align: center;
      opacity:1;
      span{
        font-weight:bold;
      }
    }
    .date{
      width: 70%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 3px;
      font-size:12px;
      font-family:PingFang SC;
      font-weight:400;
      line-height:17px;
      color:rgba(204,204,204,1);
      opacity:1;
      margin-left: 15px;
    }
    .active_tab{
      display: flex;
      justify-content: space-between;
      .record{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        line-height: 50px;
        padding: 15px;
        .recordtitle{
          font-size:16px;
          font-family:PingFang SC;
          font-weight:500;
          line-height:22px;
          opacity:1;
        }
      }
      .henxian{
        height: 100%;
        width: 2px;
        background: #F3F3F3;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/coupon/index.vue